module.exports = __webpack_public_path__ + "media/bgm.0be442fa.mp3";